import mapObjectKeys from 'utils/helpers/mapObjectKeys';

interface I_TOUR_HOOKS {
  [key: string]: (e: any) => any;
}

export const TOUR_HOOK: I_TOUR_HOOKS = {
  // useGetHowToCreateCompany,
};

interface I_TOUR_DATA {
  [key: string]: Record<string, any>[];
}

export const TOUR_DATA: I_TOUR_DATA = {
  leads: [
    // ...leads[]
  ],
  companies: [
    // ...companies[],
  ],
  deals: [
    // ...deals[],
  ],
  tasks: [
    // ...tasks[],
  ],
  pipelines: [
    // ...pipelines[],
  ],
  stages: [
    // ...stages[],
  ],
  invoices: [
    // ...invoices[],
  ],
  products: [
    // ...products[],
  ],
};

interface I_TOUR_SELECTOR {
  [key: string]: Record<string, any>;
}

const GENERAL_CREATE = ['GENERAL_CREATE'].map((key) => ({
  [key]: [
    'CREATE',
    'LEAD',
    'COMPANY',
    'DEAL',
    'INVOICE',
    'TASK',
    'EVENT',
    'BOOKING',
  ],
}));

const CONTACT = ['COMPANY', 'LEAD'].map((key) => ({
  [key]: [
    'SUBMENU',
    {
      MANAGE: ['TABLE'],
      FORM: [
        'CREATE_BUTTON',
        'SAVE_BUTTON',
        'FORM',
        {
          GENERAL: ['FORM', 'CREATE_BUTTON', 'SAVE_BUTTON'],
        },
      ],
    },
  ],
}));

const SALES = ['PIPELINE', 'STAGE', 'DEAL', 'TASK', 'INVOICE'].map((key) => ({
  [key]: [
    'SUBMENU',
    'SETTINGS_BUTTON',
    {
      MANAGE: [
        'VIEW',
        'VIEW_UPDATED',
        'MANAGE',
        'VIEW_UPDATED',
        'EDIT',
        'EDIT_BUTTON',
        'DELETE',
        'DETAILS',
        'COMPLETE_TASK',
        'THREE_DOTS_BUTTON',
        'APPROVE_DRAFT',
        'EDIT_DRAFT',
        'SEND_INVOICE',
        'SKIP_SENDING',
        'RECORD_PAYMENT',
        'CONFIGURE_BUTTON',
        'DEALS_BOARD',
        'DEALS_FILTER',
        'DEALS_CARD',
        'DEAL_COMPOSER_EDIT',
        'DEAL_COMPOSER_FORM',
        'DEAL_COMPOSER_SAVE',
      ],
      PREVIEW: ['DRAFT_BUTTON', 'DRAFT_MODAL'],
      FORM: [
        'CREATE_BUTTON',
        'SAVE_BUTTON',
        'DETAILS',
        'FORM',
        {
          GENERAL: ['FORM', 'CREATE_BUTTON', 'SAVE_BUTTON'],
        },
      ],
    },
  ],
}));

const CALENDAR = ['CALENDAR', 'BOOKING'].map((key) => ({
  [key]: [
    'SUBMENU',
    {
      MANAGE: [
        'VIEW',
        'DATE',
        'VIEW_UPDATED',
        'MANAGE',
        'MANAGE_EDIT',
        'VIEW_UPDATED',
        'EDIT',
        'EDIT_BUTTON',
        'DETAILS',
        'COMPLETE_TASK',
      ],
      FORM: [
        'CREATE_BUTTON',
        'SAVE_BUTTON',
        'DETAILS',
        'FORM',
        {
          GENERAL: ['FORM', 'CREATE_BUTTON', 'SAVE_BUTTON'],
        },
      ],
    },
  ],
}));

export const _TOUR_SELECTOR: I_TOUR_SELECTOR = mapObjectKeys({
  TOUR: [
    'BURGER',
    GENERAL_CREATE[0],
    'MENU',
    'MODAL_CLOSE_BUTTON',
    {
      CONTACT: [
        'MENU',
        CONTACT[0], // company
        CONTACT[1], // lead
      ],
    },
    {
      SALES: [
        'MENU',
        ...SALES,
        'NEW_TILE_BUTTON',
        'NEW_TILE_FORM',
        'NEW_TILE_SAVE',
      ],
    },
    {
      CALENDAR: ['MENU', CALENDAR[0], CALENDAR[1]],
    },
  ],
});

export const TOUR_SELECTOR = {
  TOUR: {
    BURGER: 'TOUR_BURGER',
    GENERAL_CREATE: {
      CREATE: 'TOUR_GENERAL_CREATE_CREATE',
      LEAD: 'TOUR_GENERAL_CREATE_LEAD',
      COMPANY: 'TOUR_GENERAL_CREATE_COMPANY',
      DEAL: 'TOUR_GENERAL_CREATE_DEAL',
      INVOICE: 'TOUR_GENERAL_CREATE_INVOICE',
      TASK: 'TOUR_GENERAL_CREATE_TASK',
      EVENT: 'TOUR_GENERAL_CREATE_EVENT',
      BOOKING: 'TOUR_GENERAL_CREATE_BOOKING',
    },
    HELP_BUTTON: 'HELP_BUTTON',
    MENU: 'TOUR_MENU',
    MODAL_CLOSE_BUTTON: 'TOUR_MODAL_CLOSE_BUTTON',
    CONTACT: {
      MENU: 'TOUR_CONTACT_MENU',
      COMPANY: {
        SUBMENU: 'TOUR_CONTACT_COMPANY_SUBMENU',
        MANAGE: { TABLE: 'TOUR_CONTACT_COMPANY_MANAGE_TABLE' },
        FORM: {
          CREATE_BUTTON: 'TOUR_CONTACT_COMPANY_FORM_CREATE_BUTTON',
          SAVE_BUTTON: 'TOUR_CONTACT_COMPANY_FORM_SAVE_BUTTON',
          FORM: 'TOUR_CONTACT_COMPANY_FORM_FORM',
          GENERAL: {
            FORM: 'TOUR_CONTACT_COMPANY_FORM_GENERAL_FORM',
            CREATE_BUTTON: 'TOUR_CONTACT_COMPANY_FORM_GENERAL_CREATE_BUTTON',
            SAVE_BUTTON: 'TOUR_CONTACT_COMPANY_FORM_GENERAL_SAVE_BUTTON',
          },
        },
      },
      LEAD: {
        SUBMENU: 'TOUR_CONTACT_LEAD_SUBMENU',
        MANAGE: { TABLE: 'TOUR_CONTACT_LEAD_MANAGE_TABLE' },
        FORM: {
          CREATE_BUTTON: 'TOUR_CONTACT_LEAD_FORM_CREATE_BUTTON',
          SAVE_BUTTON: 'TOUR_CONTACT_LEAD_FORM_SAVE_BUTTON',
          FORM: 'TOUR_CONTACT_LEAD_FORM_FORM',
          GENERAL: {
            FORM: 'TOUR_CONTACT_LEAD_FORM_GENERAL_FORM',
            CREATE_BUTTON: 'TOUR_CONTACT_LEAD_FORM_GENERAL_CREATE_BUTTON',
            SAVE_BUTTON: 'TOUR_CONTACT_LEAD_FORM_GENERAL_SAVE_BUTTON',
          },
        },
      },
    },
    SALES: {
      MENU: 'TOUR_SALES_MENU',
      PIPELINE: {
        SUBMENU: 'TOUR_SALES_PIPELINE_SUBMENU',
        SETTINGS_BUTTON: 'TOUR_SALES_PIPELINE_SETTINGS_BUTTON',
        MANAGE: {
          VIEW: 'TOUR_SALES_PIPELINE_MANAGE_VIEW',
          VIEW_UPDATED: 'TOUR_SALES_PIPELINE_MANAGE_VIEW_UPDATED',
          MANAGE: 'TOUR_SALES_PIPELINE_MANAGE_MANAGE',
          EDIT: 'TOUR_SALES_PIPELINE_MANAGE_EDIT',
          EDIT_BUTTON: 'TOUR_SALES_PIPELINE_MANAGE_EDIT_BUTTON',
          DELETE: 'TOUR_SALES_PIPELINE_MANAGE_DELETE',
          DETAILS: 'TOUR_SALES_PIPELINE_MANAGE_DETAILS',
          COMPLETE_TASK: 'TOUR_SALES_PIPELINE_MANAGE_COMPLETE_TASK',
          THREE_DOTS_BUTTON: 'TOUR_SALES_PIPELINE_MANAGE_THREE_DOTS_BUTTON',
          APPROVE_DRAFT: 'TOUR_SALES_PIPELINE_MANAGE_APPROVE_DRAFT',
          EDIT_DRAFT: 'TOUR_SALES_PIPELINE_MANAGE_EDIT_DRAFT',
          SEND_INVOICE: 'TOUR_SALES_PIPELINE_MANAGE_SEND_INVOICE',
          SKIP_SENDING: 'TOUR_SALES_PIPELINE_MANAGE_SKIP_SENDING',
          RECORD_PAYMENT: 'TOUR_SALES_PIPELINE_MANAGE_RECORD_PAYMENT',
          CONFIGURE_BUTTON: 'TOUR_SALES_PIPELINE_MANAGE_CONFIGURE_BUTTON',
          DEALS_BOARD: 'TOUR_SALES_PIPELINE_MANAGE_DEALS_BOARD',
          DEALS_FILTER: 'TOUR_SALES_PIPELINE_MANAGE_DEALS_FILTER',
          DEALS_CARD: 'TOUR_SALES_PIPELINE_MANAGE_DEALS_CARD',
          DEAL_COMPOSER_EDIT: 'TOUR_SALES_PIPELINE_MANAGE_DEAL_COMPOSER_EDIT',
          DEAL_COMPOSER_FORM: 'TOUR_SALES_PIPELINE_MANAGE_DEAL_COMPOSER_FORM',
          DEAL_COMPOSER_SAVE: 'TOUR_SALES_PIPELINE_MANAGE_DEAL_COMPOSER_SAVE',
        },
        PREVIEW: {
          DRAFT_BUTTON: 'TOUR_SALES_PIPELINE_PREVIEW_DRAFT_BUTTON',
          DRAFT_MODAL: 'TOUR_SALES_PIPELINE_PREVIEW_DRAFT_MODAL',
        },
        FORM: {
          CREATE_BUTTON: 'TOUR_SALES_PIPELINE_FORM_CREATE_BUTTON',
          SAVE_BUTTON: 'TOUR_SALES_PIPELINE_FORM_SAVE_BUTTON',
          DETAILS: 'TOUR_SALES_PIPELINE_FORM_DETAILS',
          FORM: 'TOUR_SALES_PIPELINE_FORM_FORM',
          GENERAL: {
            FORM: 'TOUR_SALES_PIPELINE_FORM_GENERAL_FORM',
            CREATE_BUTTON: 'TOUR_SALES_PIPELINE_FORM_GENERAL_CREATE_BUTTON',
            SAVE_BUTTON: 'TOUR_SALES_PIPELINE_FORM_GENERAL_SAVE_BUTTON',
          },
        },
      },
      STAGE: {
        SUBMENU: 'TOUR_SALES_STAGE_SUBMENU',
        SETTINGS_BUTTON: 'TOUR_SALES_STAGE_SETTINGS_BUTTON',
        MANAGE: {
          VIEW: 'TOUR_SALES_STAGE_MANAGE_VIEW',
          VIEW_UPDATED: 'TOUR_SALES_STAGE_MANAGE_VIEW_UPDATED',
          MANAGE: 'TOUR_SALES_STAGE_MANAGE_MANAGE',
          EDIT: 'TOUR_SALES_STAGE_MANAGE_EDIT',
          EDIT_BUTTON: 'TOUR_SALES_STAGE_MANAGE_EDIT_BUTTON',
          DELETE: 'TOUR_SALES_STAGE_MANAGE_DELETE',
          DETAILS: 'TOUR_SALES_STAGE_MANAGE_DETAILS',
          COMPLETE_TASK: 'TOUR_SALES_STAGE_MANAGE_COMPLETE_TASK',
          THREE_DOTS_BUTTON: 'TOUR_SALES_STAGE_MANAGE_THREE_DOTS_BUTTON',
          APPROVE_DRAFT: 'TOUR_SALES_STAGE_MANAGE_APPROVE_DRAFT',
          EDIT_DRAFT: 'TOUR_SALES_STAGE_MANAGE_EDIT_DRAFT',
          SEND_INVOICE: 'TOUR_SALES_STAGE_MANAGE_SEND_INVOICE',
          SKIP_SENDING: 'TOUR_SALES_STAGE_MANAGE_SKIP_SENDING',
          RECORD_PAYMENT: 'TOUR_SALES_STAGE_MANAGE_RECORD_PAYMENT',
          CONFIGURE_BUTTON: 'TOUR_SALES_STAGE_MANAGE_CONFIGURE_BUTTON',
          DEALS_BOARD: 'TOUR_SALES_STAGE_MANAGE_DEALS_BOARD',
          DEALS_FILTER: 'TOUR_SALES_STAGE_MANAGE_DEALS_FILTER',
          DEALS_CARD: 'TOUR_SALES_STAGE_MANAGE_DEALS_CARD',
          DEAL_COMPOSER_EDIT: 'TOUR_SALES_STAGE_MANAGE_DEAL_COMPOSER_EDIT',
          DEAL_COMPOSER_FORM: 'TOUR_SALES_STAGE_MANAGE_DEAL_COMPOSER_FORM',
          DEAL_COMPOSER_SAVE: 'TOUR_SALES_STAGE_MANAGE_DEAL_COMPOSER_SAVE',
        },
        PREVIEW: {
          DRAFT_BUTTON: 'TOUR_SALES_STAGE_PREVIEW_DRAFT_BUTTON',
          DRAFT_MODAL: 'TOUR_SALES_STAGE_PREVIEW_DRAFT_MODAL',
        },
        FORM: {
          CREATE_BUTTON: 'TOUR_SALES_STAGE_FORM_CREATE_BUTTON',
          SAVE_BUTTON: 'TOUR_SALES_STAGE_FORM_SAVE_BUTTON',
          DETAILS: 'TOUR_SALES_STAGE_FORM_DETAILS',
          FORM: 'TOUR_SALES_STAGE_FORM_FORM',
          GENERAL: {
            FORM: 'TOUR_SALES_STAGE_FORM_GENERAL_FORM',
            CREATE_BUTTON: 'TOUR_SALES_STAGE_FORM_GENERAL_CREATE_BUTTON',
            SAVE_BUTTON: 'TOUR_SALES_STAGE_FORM_GENERAL_SAVE_BUTTON',
          },
        },
      },
      DEAL: {
        SUBMENU: 'TOUR_SALES_DEAL_SUBMENU',
        SETTINGS_BUTTON: 'TOUR_SALES_DEAL_SETTINGS_BUTTON',
        MANAGE: {
          VIEW: 'TOUR_SALES_DEAL_MANAGE_VIEW',
          VIEW_UPDATED: 'TOUR_SALES_DEAL_MANAGE_VIEW_UPDATED',
          MANAGE: 'TOUR_SALES_DEAL_MANAGE_MANAGE',
          EDIT: 'TOUR_SALES_DEAL_MANAGE_EDIT',
          EDIT_BUTTON: 'TOUR_SALES_DEAL_MANAGE_EDIT_BUTTON',
          DELETE: 'TOUR_SALES_DEAL_MANAGE_DELETE',
          DETAILS: 'TOUR_SALES_DEAL_MANAGE_DETAILS',
          COMPLETE_TASK: 'TOUR_SALES_DEAL_MANAGE_COMPLETE_TASK',
          THREE_DOTS_BUTTON: 'TOUR_SALES_DEAL_MANAGE_THREE_DOTS_BUTTON',
          APPROVE_DRAFT: 'TOUR_SALES_DEAL_MANAGE_APPROVE_DRAFT',
          EDIT_DRAFT: 'TOUR_SALES_DEAL_MANAGE_EDIT_DRAFT',
          SEND_INVOICE: 'TOUR_SALES_DEAL_MANAGE_SEND_INVOICE',
          SKIP_SENDING: 'TOUR_SALES_DEAL_MANAGE_SKIP_SENDING',
          RECORD_PAYMENT: 'TOUR_SALES_DEAL_MANAGE_RECORD_PAYMENT',
          CONFIGURE_BUTTON: 'TOUR_SALES_DEAL_MANAGE_CONFIGURE_BUTTON',
          DEALS_BOARD: 'TOUR_SALES_DEAL_MANAGE_DEALS_BOARD',
          DEALS_FILTER: 'TOUR_SALES_DEAL_MANAGE_DEALS_FILTER',
          DEALS_CARD: 'TOUR_SALES_DEAL_MANAGE_DEALS_CARD',
          DEAL_COMPOSER_EDIT: 'TOUR_SALES_DEAL_MANAGE_DEAL_COMPOSER_EDIT',
          DEAL_COMPOSER_FORM: 'TOUR_SALES_DEAL_MANAGE_DEAL_COMPOSER_FORM',
          DEAL_COMPOSER_SAVE: 'TOUR_SALES_DEAL_MANAGE_DEAL_COMPOSER_SAVE',
        },
        PREVIEW: {
          DRAFT_BUTTON: 'TOUR_SALES_DEAL_PREVIEW_DRAFT_BUTTON',
          DRAFT_MODAL: 'TOUR_SALES_DEAL_PREVIEW_DRAFT_MODAL',
        },
        FORM: {
          CREATE_BUTTON: 'TOUR_SALES_DEAL_FORM_CREATE_BUTTON',
          SAVE_BUTTON: 'TOUR_SALES_DEAL_FORM_SAVE_BUTTON',
          DETAILS: 'TOUR_SALES_DEAL_FORM_DETAILS',
          FORM: 'TOUR_SALES_DEAL_FORM_FORM',
          GENERAL: {
            FORM: 'TOUR_SALES_DEAL_FORM_GENERAL_FORM',
            CREATE_BUTTON: 'TOUR_SALES_DEAL_FORM_GENERAL_CREATE_BUTTON',
            SAVE_BUTTON: 'TOUR_SALES_DEAL_FORM_GENERAL_SAVE_BUTTON',
          },
        },
      },
      TASK: {
        SUBMENU: 'TOUR_SALES_TASK_SUBMENU',
        SETTINGS_BUTTON: 'TOUR_SALES_TASK_SETTINGS_BUTTON',
        MANAGE: {
          VIEW: 'TOUR_SALES_TASK_MANAGE_VIEW',
          VIEW_UPDATED: 'TOUR_SALES_TASK_MANAGE_VIEW_UPDATED',
          MANAGE: 'TOUR_SALES_TASK_MANAGE_MANAGE',
          EDIT: 'TOUR_SALES_TASK_MANAGE_EDIT',
          EDIT_BUTTON: 'TOUR_SALES_TASK_MANAGE_EDIT_BUTTON',
          DELETE: 'TOUR_SALES_TASK_MANAGE_DELETE',
          DETAILS: 'TOUR_SALES_TASK_MANAGE_DETAILS',
          COMPLETE_TASK: 'TOUR_SALES_TASK_MANAGE_COMPLETE_TASK',
          THREE_DOTS_BUTTON: 'TOUR_SALES_TASK_MANAGE_THREE_DOTS_BUTTON',
          APPROVE_DRAFT: 'TOUR_SALES_TASK_MANAGE_APPROVE_DRAFT',
          EDIT_DRAFT: 'TOUR_SALES_TASK_MANAGE_EDIT_DRAFT',
          SEND_INVOICE: 'TOUR_SALES_TASK_MANAGE_SEND_INVOICE',
          SKIP_SENDING: 'TOUR_SALES_TASK_MANAGE_SKIP_SENDING',
          RECORD_PAYMENT: 'TOUR_SALES_TASK_MANAGE_RECORD_PAYMENT',
          CONFIGURE_BUTTON: 'TOUR_SALES_TASK_MANAGE_CONFIGURE_BUTTON',
          DEALS_BOARD: 'TOUR_SALES_TASK_MANAGE_DEALS_BOARD',
          DEALS_FILTER: 'TOUR_SALES_TASK_MANAGE_DEALS_FILTER',
          DEALS_CARD: 'TOUR_SALES_TASK_MANAGE_DEALS_CARD',
          DEAL_COMPOSER_EDIT: 'TOUR_SALES_TASK_MANAGE_DEAL_COMPOSER_EDIT',
          DEAL_COMPOSER_FORM: 'TOUR_SALES_TASK_MANAGE_DEAL_COMPOSER_FORM',
          DEAL_COMPOSER_SAVE: 'TOUR_SALES_TASK_MANAGE_DEAL_COMPOSER_SAVE',
        },
        PREVIEW: {
          DRAFT_BUTTON: 'TOUR_SALES_TASK_PREVIEW_DRAFT_BUTTON',
          DRAFT_MODAL: 'TOUR_SALES_TASK_PREVIEW_DRAFT_MODAL',
        },
        FORM: {
          CREATE_BUTTON: 'TOUR_SALES_TASK_FORM_CREATE_BUTTON',
          SAVE_BUTTON: 'TOUR_SALES_TASK_FORM_SAVE_BUTTON',
          DETAILS: 'TOUR_SALES_TASK_FORM_DETAILS',
          FORM: 'TOUR_SALES_TASK_FORM_FORM',
          GENERAL: {
            FORM: 'TOUR_SALES_TASK_FORM_GENERAL_FORM',
            CREATE_BUTTON: 'TOUR_SALES_TASK_FORM_GENERAL_CREATE_BUTTON',
            SAVE_BUTTON: 'TOUR_SALES_TASK_FORM_GENERAL_SAVE_BUTTON',
          },
        },
      },
      INVOICE: {
        SUBMENU: 'TOUR_SALES_INVOICE_SUBMENU',
        SETTINGS_BUTTON: 'TOUR_SALES_INVOICE_SETTINGS_BUTTON',
        MANAGE: {
          VIEW: 'TOUR_SALES_INVOICE_MANAGE_VIEW',
          VIEW_UPDATED: 'TOUR_SALES_INVOICE_MANAGE_VIEW_UPDATED',
          MANAGE: 'TOUR_SALES_INVOICE_MANAGE_MANAGE',
          EDIT: 'TOUR_SALES_INVOICE_MANAGE_EDIT',
          EDIT_BUTTON: 'TOUR_SALES_INVOICE_MANAGE_EDIT_BUTTON',
          DELETE: 'TOUR_SALES_INVOICE_MANAGE_DELETE',
          DETAILS: 'TOUR_SALES_INVOICE_MANAGE_DETAILS',
          COMPLETE_TASK: 'TOUR_SALES_INVOICE_MANAGE_COMPLETE_TASK',
          THREE_DOTS_BUTTON: 'TOUR_SALES_INVOICE_MANAGE_THREE_DOTS_BUTTON',
          APPROVE_DRAFT: 'TOUR_SALES_INVOICE_MANAGE_APPROVE_DRAFT',
          EDIT_DRAFT: 'TOUR_SALES_INVOICE_MANAGE_EDIT_DRAFT',
          SEND_INVOICE: 'TOUR_SALES_INVOICE_MANAGE_SEND_INVOICE',
          SKIP_SENDING: 'TOUR_SALES_INVOICE_MANAGE_SKIP_SENDING',
          RECORD_PAYMENT: 'TOUR_SALES_INVOICE_MANAGE_RECORD_PAYMENT',
          CONFIGURE_BUTTON: 'TOUR_SALES_INVOICE_MANAGE_CONFIGURE_BUTTON',
          DEALS_BOARD: 'TOUR_SALES_INVOICE_MANAGE_DEALS_BOARD',
          DEALS_FILTER: 'TOUR_SALES_INVOICE_MANAGE_DEALS_FILTER',
          DEALS_CARD: 'TOUR_SALES_INVOICE_MANAGE_DEALS_CARD',
          DEAL_COMPOSER_EDIT: 'TOUR_SALES_INVOICE_MANAGE_DEAL_COMPOSER_EDIT',
          DEAL_COMPOSER_FORM: 'TOUR_SALES_INVOICE_MANAGE_DEAL_COMPOSER_FORM',
          DEAL_COMPOSER_SAVE: 'TOUR_SALES_INVOICE_MANAGE_DEAL_COMPOSER_SAVE',
        },
        PREVIEW: {
          DRAFT_BUTTON: 'TOUR_SALES_INVOICE_PREVIEW_DRAFT_BUTTON',
          DRAFT_MODAL: 'TOUR_SALES_INVOICE_PREVIEW_DRAFT_MODAL',
        },
        FORM: {
          CREATE_BUTTON: 'TOUR_SALES_INVOICE_FORM_CREATE_BUTTON',
          SAVE_BUTTON: 'TOUR_SALES_INVOICE_FORM_SAVE_BUTTON',
          DETAILS: 'TOUR_SALES_INVOICE_FORM_DETAILS',
          FORM: 'TOUR_SALES_INVOICE_FORM_FORM',
          GENERAL: {
            FORM: 'TOUR_SALES_INVOICE_FORM_GENERAL_FORM',
            CREATE_BUTTON: 'TOUR_SALES_INVOICE_FORM_GENERAL_CREATE_BUTTON',
            SAVE_BUTTON: 'TOUR_SALES_INVOICE_FORM_GENERAL_SAVE_BUTTON',
          },
        },
      },
      NEW_TILE_BUTTON: 'TOUR_SALES_NEW_TILE_BUTTON',
      NEW_TILE_FORM: 'TOUR_SALES_NEW_TILE_FORM',
      NEW_TILE_SAVE: 'TOUR_SALES_NEW_TILE_SAVE',
    },
    CALENDAR: {
      MENU: 'TOUR_CALENDAR_MENU',
      CALENDAR: {
        SUBMENU: 'TOUR_CALENDAR_CALENDAR_SUBMENU',
        MANAGE: {
          VIEW: 'TOUR_CALENDAR_CALENDAR_MANAGE_VIEW',
          DATE: 'TOUR_CALENDAR_CALENDAR_MANAGE_DATE',
          VIEW_UPDATED: 'TOUR_CALENDAR_CALENDAR_MANAGE_VIEW_UPDATED',
          MANAGE: 'TOUR_CALENDAR_CALENDAR_MANAGE_MANAGE',
          MANAGE_EDIT: 'TOUR_CALENDAR_CALENDAR_MANAGE_MANAGE_EDIT',
          EDIT: 'TOUR_CALENDAR_CALENDAR_MANAGE_EDIT',
          EDIT_BUTTON: 'TOUR_CALENDAR_CALENDAR_MANAGE_EDIT_BUTTON',
          DETAILS: 'TOUR_CALENDAR_CALENDAR_MANAGE_DETAILS',
          COMPLETE_TASK: 'TOUR_CALENDAR_CALENDAR_MANAGE_COMPLETE_TASK',
        },
        FORM: {
          CREATE_BUTTON: 'TOUR_CALENDAR_CALENDAR_FORM_CREATE_BUTTON',
          SAVE_BUTTON: 'TOUR_CALENDAR_CALENDAR_FORM_SAVE_BUTTON',
          DETAILS: 'TOUR_CALENDAR_CALENDAR_FORM_DETAILS',
          FORM: 'TOUR_CALENDAR_CALENDAR_FORM_FORM',
          GENERAL: {
            FORM: 'TOUR_CALENDAR_CALENDAR_FORM_GENERAL_FORM',
            CREATE_BUTTON: 'TOUR_CALENDAR_CALENDAR_FORM_GENERAL_CREATE_BUTTON',
            SAVE_BUTTON: 'TOUR_CALENDAR_CALENDAR_FORM_GENERAL_SAVE_BUTTON',
          },
        },
      },
      BOOKING: {
        SUBMENU: 'TOUR_CALENDAR_BOOKING_SUBMENU',
        MANAGE: {
          VIEW: 'TOUR_CALENDAR_BOOKING_MANAGE_VIEW',
          DATE: 'TOUR_CALENDAR_BOOKING_MANAGE_DATE',
          VIEW_UPDATED: 'TOUR_CALENDAR_BOOKING_MANAGE_VIEW_UPDATED',
          MANAGE: 'TOUR_CALENDAR_BOOKING_MANAGE_MANAGE',
          MANAGE_EDIT: 'TOUR_CALENDAR_BOOKING_MANAGE_MANAGE_EDIT',
          EDIT: 'TOUR_CALENDAR_BOOKING_MANAGE_EDIT',
          EDIT_BUTTON: 'TOUR_CALENDAR_BOOKING_MANAGE_EDIT_BUTTON',
          DETAILS: 'TOUR_CALENDAR_BOOKING_MANAGE_DETAILS',
          COMPLETE_TASK: 'TOUR_CALENDAR_BOOKING_MANAGE_COMPLETE_TASK',
        },
        FORM: {
          CREATE_BUTTON: 'TOUR_CALENDAR_BOOKING_FORM_CREATE_BUTTON',
          SAVE_BUTTON: 'TOUR_CALENDAR_BOOKING_FORM_SAVE_BUTTON',
          DETAILS: 'TOUR_CALENDAR_BOOKING_FORM_DETAILS',
          FORM: 'TOUR_CALENDAR_BOOKING_FORM_FORM',
          GENERAL: {
            FORM: 'TOUR_CALENDAR_BOOKING_FORM_GENERAL_FORM',
            CREATE_BUTTON: 'TOUR_CALENDAR_BOOKING_FORM_GENERAL_CREATE_BUTTON',
            SAVE_BUTTON: 'TOUR_CALENDAR_BOOKING_FORM_GENERAL_SAVE_BUTTON',
          },
        },
      },
    },
  },
};

export default {
  TOUR_HOOK,
  TOUR_DATA,
  TOUR_SELECTOR,
};
